export default __webpack_public_path__ + "static/media/open.94872c15.svg";